import { useEffect, useRef } from "react";
import useBranchId from "./useBranchId";
import useEnabledWindowReload from "../atoms/useEnabledWindowReload";

const useReloadWindowOnBranchIdChange = () => {
  const prevBranch = useRef<number | undefined>(undefined);
  const branchId = useBranchId();
  const [enabledWindowReload, setEnabledWindowReload] =
    useEnabledWindowReload();

  useEffect(() => {
    if (
      prevBranch.current !== undefined &&
      prevBranch.current !== branchId &&
      enabledWindowReload
    ) {
      window.location.reload();
    }
    setEnabledWindowReload(true);
    prevBranch.current = branchId;
  }, [branchId]);
};

export default useReloadWindowOnBranchIdChange;
